var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":_vm.clicked}},[(_vm.widgets)?_c('v-runtime-template',{attrs:{"template":_vm.widgets}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }